var React = require('react');

function IconSearch (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.2771 13.4316L10.9079 9.92744C11.7741 8.89764 12.2488 7.60195 12.2488 6.25307C12.2488 3.10155 9.68473 0.537491 6.53321 0.537491C3.38169 0.537491 0.817627 3.10155 0.817627 6.25307C0.817627 9.40459 3.38169 11.9687 6.53321 11.9687C7.71633 11.9687 8.84379 11.6118 9.80774 10.9344L13.2025 14.4651C13.3444 14.6125 13.5353 14.6937 13.7398 14.6937C13.9334 14.6937 14.117 14.6199 14.2564 14.4857C14.5527 14.2007 14.5621 13.7281 14.2771 13.4316ZM6.53321 2.02851C8.86268 2.02851 10.7578 3.9236 10.7578 6.25307C10.7578 8.58254 8.86268 10.4776 6.53321 10.4776C4.20374 10.4776 2.30865 8.58254 2.30865 6.25307C2.30865 3.9236 4.20374 2.02851 6.53321 2.02851Z","fill":"white"}));
}

IconSearch.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = IconSearch;

IconSearch.default = IconSearch;
